
import('../src/javascripts/attachments-redesign');
import('../src/javascripts/slider_splide');
import('../src/javascripts/navigation');
